module.exports = __webpack_public_path__ + "media/images/emblems/Weiach-901c14c43f655bb0d0df5a1aff6e1562.svg";